import React from 'react'
import ReCAPTCHA from "react-google-recaptcha"
import {Field, useFormikContext} from "formik"
import {useTranslation} from "react-i18next";
import store from "@formApp/store"

export default () => {
  const {formValues} = React.useContext(store);
  const recaptchaRef = React.useRef(null);
  React.useEffect(() => {
    formValues.setRecaptchaRef(recaptchaRef.current);
  }, [recaptchaRef.current]);
  const {
    setFieldValue,
  } = useFormikContext();
  const {i18n} = useTranslation();
  const verifyCallback = (recaptchaToken) => {
    setFieldValue('g-recaptcha-response', recaptchaToken);
  };

  return (
    <Field name='g-recaptcha-response'>
      {({field, meta: { touched, error, value }}) => (
        <div className={`formGroup${(touched && error) ? ' error' : ''}`}>
          <ReCAPTCHA
            ref={recaptchaRef}
            hl={i18n.language}
            sitekey="6Lf20RITAAAAAOCcnnOeXBqgUdEtZg6evQutkk_O"
            onChange={verifyCallback}
          />
          {touched && error && <div className="errorMessage">{error}</div>}
        </div>
      )}
    </Field>
  )
}